/** В проде конфигурация подставляется сервером в HTML из env контейнера. */
declare global {
  interface Window {
    __RUNTIME_ENV__?: Record<string, string>
  }
}

function value(name: string): string | undefined {
  const runtime = window.__RUNTIME_ENV__
  if (runtime) return runtime[name] || undefined
  // Локальная разработка и vite preview.
  return import.meta.env[name] as string | undefined
}

export const env = {
  /** Префикс, на который ходит фронт. Проксируется на бэкенд бренда. */
  apiBase: value('VITE_API_BASE') ?? '/api',
  /** Длина кода из SMS; у брендов бывает 4 или 6 */
  otpLength: Number(value('VITE_OTP_LENGTH')) || 4,
  /** Ключ reCAPTCHA v3; бэкенд требует токен на отправку SMS */
  recaptchaSiteKey: value('VITE_RECAPTCHA_SITE_KEY') ?? '',
  /** Ключ JS API Яндекс.Карт: карта, подсказки адресов и геокодирование */
  mapKey: value('VITE_MAP_KEY') ?? '',
  /**
   * Сервис чата. REST ходит через прокси, а SignalR-хаб браузер держит сам —
   * поэтому адрес и ключ здесь. Ключ статический и общий с мобильным
   * приложением, из его сборки он достаётся так же легко.
   */
  chatUrl: value('VITE_CHAT_URL') ?? '',
  chatKey: value('VITE_CHAT_API_KEY') ?? '',
} as const
